import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from 'store/actions/evaluation.action'
import * as fromLessonActions from 'store/actions/lessons.action'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import sendEvaluation, {
  ResSendEvaluation,
} from 'api/evaluation/sendEvaluation'
import { IUserAnswer } from 'components/courses/lessons/components/LessonCard/components/ContentBlock/components/evaluation/Evaluation'
import { ActionWithPayload } from 'helpers/redux-actions.helper'

const pattern = fromActions.SEND_EVALUATION

async function handleSendEvaluation(data: any) {
  return sendEvaluation(data)
}

export type SendEvaluationAction = ActionWithPayload<
  typeof pattern,
  fromActions.PayloadSendEvaluation
>

function* sendEvaluationEffectSaga(action: SendEvaluationAction) {
  const {
    payload: {
      courseId,
      blockEvaluationId,
      blockInstanceId,
      answers,
      lessonId,
      blockInstances,
      onSuccess,
      onError,
    },
  } = action
  try {
    const data = {
      evaluation: {
        courseId,
        blockEvaluationId,
        questionsLikersAttributes: [] as any,
      },
    }
    data.evaluation.questionsLikersAttributes = answers.map(
      ({ id, questionId }: IUserAnswer) => {
        return {
          questionsLikertLabelId: id,
          answerAttributes: {
            blockInstanceId,
            questionId,
          },
        }
      }
    )
    const { status, data: resData } = yield call(handleSendEvaluation, data)
    const dataSendEvaluation: ResSendEvaluation = resData
    onSuccess?.(dataSendEvaluation.data.attributes)
    if (status === 200)
      yield put(
        fromLessonActions.Actions.lessonsGetLessonContent({
          blockInstances,
          lessonId,
        })
      )
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    onError?.(error)
    console.log('error: ', error)
  }
}

export function* sendEvaluationWatcherSaga() {
  yield takeLatest(pattern, sendEvaluationEffectSaga)
}
